<template>
	<div class="info">
		<div>
			<InformationIcon />
		</div>
		<transition name="tooltip">
			<div class="info-box">
				<div class="password-rules">
					<PasswordRules
						ref="passwordRules"
						:password="password"
						:confirmPassword="confirmPassword"
						:tooltip="true"
						:big="true"
					/>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import InformationIcon from '@/components/shared/Icons/InformationIcon.vue';
import PasswordRules from '@/components/modules/Login/PasswordRules/PasswordRules.vue';

export default {
	name: 'InfoPasswordTooltip',
	components: {
		InformationIcon,
		PasswordRules,
	},
	props: {
		password: {
			default: '',
		},
		confirmPassword: {
			default: '',
		},
	},
	data: () => ({}),
	mounted() {},
	methods: {},
	computed: {},
};
</script>

<style lang="scss" scoped>
@import 'InfoPasswordTooltip.scss';
</style>
